import { TransformPlainObject } from './transform.plainObject';
import { AssertExpressionPlainObject } from './assertExpression.plainObject';

export class AssertPlainObject extends TransformPlainObject {
    public asserts: AssertExpressionPlainObject[] = [];
}
